import React from 'react'

import {getStatusText, UNAUTHORIZED, FORBIDDEN, INTERNAL_SERVER_ERROR} from 'http-status-codes'

import Header from './layout/Header'
import Footer from './layout/Footer'

import Campaign from './pages/Campaign'
import Login from './pages/Login'

const EMPTY_CAMPAIGN = {}
const INITIAL_STATE = {
    campaign: EMPTY_CAMPAIGN,
    isLoading: false,
    loginMessage: '',
    loginForm: {
        partnerId: '',
        partnerPassword: ''
    },
    user: {
        token: null,
        isAuthenticated: false
    },
    isMobile: {
        web: false,
        email: false,
        brandPage: false
    }
}

export default class App extends React.Component {

    state = INITIAL_STATE

    async authenticate() {

        this.setState({isLoading: true})

        const {res: {ok, status}, token} = await this.requestAuthToken()

        ok && token.length
            ? await this.handleAuthSuccess(token)
            : status === UNAUTHORIZED
                ? this.handleAuthUnauthorized()
                : this.handleAuthFail()
    }

    async requestAuthToken() {

        const {partnerId, partnerPassword} = this.state.loginForm

        const res = await fetch('/api/auth', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: `{"partnerId":"${partnerId}","partnerPassword":"${partnerPassword}"}`
        })

        const token = await res.text()

        return {res, token}
    }

    async handleAuthSuccess(token) {

        this.setState({
            loginMessage: INITIAL_STATE.loginMessage,
            user: {
                token,
                isAuthenticated: false
            }
        })

        const campaign = await this.fetchCampaign()

        if (Object.keys(campaign).length) {

		  	this.patchMissingImages(campaign.blocks)
            this.setDocumentLang(campaign.languageVersion)

            this.setState({
                campaign,
                isLoading: false,
                loginForm: INITIAL_STATE.loginForm,
                user: {isAuthenticated: true, token: INITIAL_STATE.user.token}
            })
        }
    }

    async fetchCampaign() {

        const {cid} = this.props.match.params

        try {

            const res = await fetch(`/api/${cid}`, {
                headers: {'Authorization': `Bearer ${this.state.user.token}`}
            })

            if (res.ok) {
                return await res.json()
            } else if (res.status === FORBIDDEN) {
                this.handleAuthForbidden()
            }

            return EMPTY_CAMPAIGN

        } catch (e) {
            console.warn(e)
            this.setState({isLoading: false})
        }
    }

    handleAuthForbidden() {

        console.warn(getStatusText(FORBIDDEN))

        this.resetFormAndShowMessage('You are not allowed to view this campaign!')
    }

    handleAuthUnauthorized() {

        console.warn(getStatusText(UNAUTHORIZED))

        this.resetFormAndShowMessage('Wrong username or password!')
    }

    handleAuthFail() {

        console.warn(getStatusText(INTERNAL_SERVER_ERROR))

        this.resetFormAndShowMessage('Something went wrong, please try again later!')
    }

    resetFormAndShowMessage(message) {

        this.setState({
            loginMessage: message,
            loginForm: INITIAL_STATE.loginForm,
            isLoading: false
        })
    }

    onLoginFormChange({target}) {

        this.setState(({loginForm}) => ({
            loginForm: {
                ...loginForm,
                [target.name]: target.value
            }
        }))
    }

    onViewToggle(id) {

        this.setState(({isMobile}) =>({
            isMobile: {
                ...isMobile,
                [id]: !isMobile[id]
            }
        }))
    }

    setDocumentLang(lang) {
        document.documentElement.setAttribute('lang', lang.toLowerCase())
    }


    patchMissingImages(blocks) {

        const imageFallbacks = {
            image_16_9: '700x395',
            image_5_2: '1800x720',
            image_3_4: '540x720',
            image_1_1: '720x720',
            image_3_2: '1080x720',
            image_app: '1242x1027',
            image_revolving_stage: '944x420',
            image_key_visual: '768x420',
            image_offer_teaser: '412x260',
            image_award_booking: '575x256',
            image_lounge_teaser: '272x230',
            image_promotion_offer_page: '202x128',
            image_standard_offer_page: '412x260',
            image_top_offer_slot: '280x187',
            image_two_column_offer: '280x187',
            image_teaser_app_stream_basic: '1109x695'
        }

        for (let key in blocks) {
            if (!blocks.hasOwnProperty(key) || key.indexOf('image_') === -1) continue

            blocks[key] = blocks[key] || 'https://via.placeholder.com/' + imageFallbacks[key]
        }
    }

    logout = () => this.setState(INITIAL_STATE)

    renderLogin = () => (
        <React.Fragment>
            <Header />
            <div className="page static-footer">
                <Login authenticate={this.authenticate.bind(this)}
                       onChange={this.onLoginFormChange.bind(this)}
                       loginForm={this.state.loginForm}
                       loginMessage={this.state.loginMessage}
                       isLoading={this.state.isLoading} />
            </div>
            <Footer />
        </React.Fragment>
    )

    renderCampaign = () => (
        <React.Fragment>
            <Header logout={this.logout} isAuthenticated={this.state.user.isAuthenticated} />
            <div className="page">
                <Campaign
                    campaign={this.state.campaign}
                    routeParams={this.props.match.params}
                    isMobile={this.state.isMobile}
                    onViewToggle={this.onViewToggle.bind(this)} />
            </div>
            <Footer />
        </React.Fragment>
    )

    render() {

        return (
            this.state.user.isAuthenticated && this.state.campaign
                ? this.renderCampaign()
                : this.renderLogin()
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/App.js